import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales/i18n';
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { Row, Column, Hidden } from 'vue-grid-responsive';
import "@/scss/fontFace.scss";


createApp(App)
.use(router)
.use(store)
.use(i18n)
.use(Toast, {
    transition: "Vue-Toastification__bounce",
    maxToasts: 20,
    newestOnTop: true,
    position: POSITION.BOTTOM_CENTER,
    timeout: 4000,
    closeOnClick: true,
    closeButton: "button",
  })
.component('rowResp', Row)
.component('columnResp', Column)
.component('hiddenResp', Hidden)
.mount('#app')
